module.exports = __webpack_public_path__ + "media/images/realizacje/real9-06da74bea5b1733313fed8e7ca7639fb.png";